export const TERMLY_ROOT_ID = 'termly-code-snippet-support';

export const TERMLY_SCRIPT_ID = 'termly-cmp';

export const TERMLY_ORIGIN = 'https://app.termly.io';

const TERMLY_SCRIPT_BASE = `${TERMLY_ORIGIN}/resource-blocker`;

export function getTermlyScriptUrl(websiteUuid: string) {
  return `${TERMLY_SCRIPT_BASE}/${websiteUuid}?autoBlock=on`;
}
